module.exports = __webpack_public_path__ + "media/images/cover/person-bar-f944bc1e809750f0611f4e9a18faf46c.jpeg";